// extracted by mini-css-extract-plugin
export default {"container":"XP-z","darkBackground":"YP-z","whiteBackground":"ZP-z","headerButton":"_P-z","calloutHeading":"aQ-z","calloutSubHeading":"bQ-z"};